<template>
  <div class="page update-page">
    <Header title="激活账号"></Header>
    <ActivationStep :activeNum="2"></ActivationStep>
  <div>
      <van-form @submit="onSubmit" ref="submitForm">
        <van-field
          v-model="params.applyInviteCode"
          name="推荐码"
          label="推荐码"
          placeholder="请输入推荐码"
        />
        <van-field
          v-model="params.clientName"
          name="公司名称"
          label="公司名称"
          placeholder="请输入公司名称"
          :rules="[{ required: true, message: '请输入公司名称' }]"
        />
        <van-field
          v-model="params.contactPerson"
          name="姓名"
          label="姓名"
          placeholder="请输入姓名"
          :rules="[{ required: true, message: '请输入姓名' }]"
        />
        <van-field v-model="params.contactMobile" type="tel" label="手机号"
          placeholder="请输入手机号"
          :rules="rules.mobileRule">
            <template #button>
              <div :style="disableSendBtn?'color:grey':'color:#00545e'" @click="getVerifyCode">获取验证码{{countDownText}}</div>
            </template>
        </van-field>
        <van-field v-model="params.verifyCode" type="number" label="验证码"
          placeholder="请输入验证码"
          :rules="[{ required: true, message: '请输入验证码' }]" />
        <van-field v-model="params.contactEmail" label="邮箱"
          placeholder="请输入邮箱"
          :rules="rules.emailRule" />
        <van-field
          readonly
          clickable
          label="城市"
          :value="value"
          placeholder="选择城市"
          @click="showPicker=true"
          :rules="[{ required: true, message: '请选择城市' }]"
        />
        <van-field v-model="params.detailAddress" label="详细地址"
          placeholder="请输入详细地址"
          :rules="[{ required: true, message: '请输入详细地址' }]" />

        <div class="register-field">
          <div class="register-field-title">请上传申请表</div>
          <div class="field-btn">下载申请表</div>
          <van-uploader v-model="fileList" :max-count="1" :after-read="afterRead" >
            <div class="upload-icon"> + </div>
          </van-uploader>
        </div>
        <div style="margin: 16px;">
          <van-button color="#00545e" @click="submit()" block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker @change="change" ref="picker" show-toolbar :columns="columns" @cancel="handleCancelAddress()" @confirm="submitAddress()" />
      </van-popup>

  </div>
  </div>

</template>

<script>
import Header from '@/components/header'
import ActivationStep from '@/components/activation-step'
import { mapState } from 'vuex'
import centerApi from '../../api/center'
import fileApi from '../../api/file'
import validators from '@/utils/validators'
export default {
  components: {
    Header,
    ActivationStep
  },
  data () {
    var checkPassword = validators.checkPassword
    var checkEmail = validators.checkEmail
    var checkMobile = validators.checkMobile
    var checkPasswordAgain = (val) => {
      if (val !== this.params.password) {
        return false
      }
    }
    return {
      params: {
        applyType: '01',
        verifyCode: '',
        applyInviteCode: '',
        clientName: '',
        contactPerson: '',
        contactMobile: '',
        detailAddress: '',
        contactEmail: '',
        authorizeFileId: '',
        password: '',
        passwordAgain: ''
      },
      detailAddress: '',
      showArea: false,
      areaList: {},
      newProvinceArray: [],
      newCityArray: [],
      newCountyArray: [],
      countyArray: [],
      provinceId: 0,
      cityId: 0,
      countyId: 0,
      columns: [{ values: [] }, { values: [] }, { values: [] }],
      showPicker: false,
      value: '',
      fileList: [],
      authorizeFileId: '',
      disableSendBtn: false,
      countDownIndex: 0,
      registerOverlay: false,
      selectOverlay: false,
      clientList: [],
      applyType: '01',
      queryParam: '',
      clientId: '',
      noData: false,
      rules: {
        passwordRule: [{ required: true, validator: checkPassword, message: '密码必须由8-12位数字,大小写字母和特殊字符其中三种组成' }],
        passwordAgainRule: [{ required: true, validator: checkPasswordAgain, message: '两次密码输入不一致' }],
        mobileRule: [{ required: true, validator: checkMobile, message: '请输入正确手机号' }],
        emailRule: [{ required: true, validator: checkEmail, message: '请输入正确邮箱' }]
      }
    }
  },
  computed: {
    ...mapState({
      provinceArray: state => state.base.provinceArray,
      cityArray: state => state.base.cityArray
    }),

    countDownText () {
      return this.countDownIndex > 0 ? '(' + this.countDownIndex + ')' : ''
    }
  },
  watch: {
    'provinceArray' () {
      this.initProvince()
    },
    'provinceId' () {
      let provinceCode = this.provinceArray[this.provinceId].provinceCode
      console.log(provinceCode)
      let params = {
        provinceCode
      }
      // this.cityArray = []
      this.$store.dispatch('base_a_cityData', { params }).then(res => {
        this.cityArray = this.$store.state.base.cityArray
        this.initCity()

        this.handleCityChange(0)
      })
    },
    'cityArray' () {
      this.initCity()
    },
    'cityId' () {
      this.handleCityChange(this.cityId)
    }
  },
  created () {
    this.getClientInfo()
    this.$store.dispatch('base_a_provinceData')
    this.$store.dispatch('base_a_cityData', { params: { provinceCode: '110000' } })
    // this.$store.dispatch('base_a_countyData', { params: { cityCode: '110100' } })
    this.$store.dispatch('base_a_countyData', { params: { cityCode: '110100' } }).then(res => {
      this.countyArray = this.$store.state.base.countyArray
      this.initCounty()
    })
  },
  methods: {
    getClientInfo () {
      centerApi.getClientInfo().then(res => {
        if (res.data.resultCode === '0') {
          let clientInfo = res.data.resultData.clientInfo
          this.params.applyInviteCode = clientInfo.applyInviteCode
          this.params.clientName = clientInfo.clientName
          this.params.contactPerson = clientInfo.clientUserDTO.userName
          this.params.contactMobile = clientInfo.clientUserDTO.userMobile
          this.params.contactEmail = clientInfo.clientUserDTO.userMail
          this.value = clientInfo.provinceName + ' ' + clientInfo.provinceName + ' ' + clientInfo.provinceName + ' '
          this.params.detailAddress = clientInfo.detailAddress
        }
      })
    },
    initProvince () {
      for (let item of this.provinceArray) {
        this.newProvinceArray.push(item.provinceName)
      }
      this.columns[0].values = this.newProvinceArray
    },
    initCity () {
      this.newCityArray = []
      for (let item of this.cityArray) {
        this.newCityArray.push(item.cityName)
      }
      this.columns[1].values = this.newCityArray
    },
    initCounty () {
      this.newCountyArray = []
      for (let item of this.countyArray) {
        this.newCountyArray.push(item.countyName)
      }
      console.log(this.newCountyArray)
      this.columns[2].values = this.newCountyArray
    },
    handleCityChange (cityId) {
      let cityCode = this.cityArray[cityId].cityCode
      let params = {
        cityCode
      }
      console.log(params)
      this.$store.dispatch('base_a_countyData', { params }).then(res => {
        this.countyArray = this.$store.state.base.countyArray
        this.initCounty()
      })
    },
    change (picker, value, index) {
      this.provinceId = this.$refs.picker.getIndexes()[0]
      console.log(this.provinceId)
      this.cityId = this.$refs.picker.getIndexes()[1]
      console.log(this.cityId)
    },
    validator (val) {
      if (val === '' || this.params.passwordAgain === '') {
        return false
      } else if (val !== this.params.password) {
        return false
      }
    },

    onSubmit (values) {
      if (!this.params.authorizeFileId) {
        this.$toast('请上传申请表！')
        return
      }
      this.params.provinceId = this.provinceId
      this.params.cityId = this.cityId
      this.params.countyId = this.countyId
      centerApi.registerSubmit(this.params).then(res => {
        if (res.data.resultCode === '0') {
          this.$dialog.alert({
            title: '提示',
            message: '修改成功！'
          }).then(() => {
            this.$router.push({ name: 'activation_step_two' })
          })
        }
      })
    },
    gotoLogin (contactMobile, clientId) {
      this.$router.push({ name: 'login2', query: { contactMobile, clientId } })
    },
    getVerifyCode () {
      if (this.disableSendBtn) {
        return
      }
      let params = {
        phoneNumber: this.params.contactMobile
      }
      centerApi.sendClientVerifyCode(params).then(res => {
        if (res.data.resultCode === '0') {
          this.countDownIndex = 60
          this.disableSendBtn = true
          this.countDown()
        }
      })
    },
    countDown () {
      this.countDownIndex = 60
      let _vm = this
      let timer = setInterval(() => {
        _vm.countDownIndex--
        if (_vm.countDownIndex === 0) {
          _vm.disableSendBtn = false
          clearInterval(timer)
        }
      }, 1000)
    },
    afterRead (file) {
      fileApi
        .uploadFilePublic(file.file)
        .then((response) => {
          if (response.data.resultCode === '0') {
            let fileDTO = response.data.resultData.fileDTO
            this.params.authorizeFileId = fileDTO.fileId
          }
        })
        .catch(() => {
        })
    },

    submitAddress () {
      this.value = this.$refs.picker.getValues().join(' ')
      console.log(this.$refs.picker.getValues())
      this.showPicker = false
    },
    handleCancelAddress () {
      this.value = ''
      this.showPicker = false
    },
    onSearch () {
      let params = {
        queryParam: this.queryParam
      }
      centerApi.publicWorkshopQuery(params).then(res => {
        if (res.data.resultCode === '0') {
          this.clientList = []
          if (res.data.resultData && res.data.resultData.clientList) {
            this.clientList = res.data.resultData.clientList
            this.noData = false
          } else {
            this.noData = true
          }
        }
      })
    },
    selectClientId (item) {
      this.clientId = item.clientId
      this.params.clientId = item.clientId
      console.log(this.params)
      this.params.clientName = item.clientName
    },
    submit () {
      this.$refs.submitForm.submit()
    }
  }
}
</script>

<style lang="less" scoped>
.upload-icon{
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: dashed 2px rgb(190, 190, 190);
  font-size: 30px;
  text-align: center;
  color: rgb(190, 190, 190);
}
.van-uploader{
  margin-top: 15px;
}
.register-field{
  margin:20px  15px;
  .register-field-title{
    font-weight:bolder;
    font-size: 16px;
  }
}
.field-btn{
  position: absolute;
  right: 15px;
  line-height: 40px;
  color:#00545e
}
</style>
